/**
 * 公共树：配置任意业务数据来源和任意统计数据来源，生成不同的树（可配置是否显示统计数），并过滤右侧表格数据
 * weili 2022-10-22
 */
export default {
    data() {
      return {
        // autoLoad: true,
        treeList : [],
        loading: false,
      }
    },
    methods: {
      async handleCodeTree() {
        if (!this.treeDataApi) return
        if (this.beforeAction) {
          this.beforeAction()
        }
        this.loading = true
        let res = await this.treeDataApi(this.treeDataParams) //树数据
        this.loading = false
        const body = res && res.body ? res.body : {}
        const list = body.list || []
        let treeList = this.modifyTreeConfigNoNumber(list)
        this.treeList = treeList   
      },
      async handleSpecialCodeTree() {
        if (!this.treeDataApi) return
        if (!this.treeCountApi) return
        if (this.beforeAction) {
          this.beforeAction()
        }
        this.loading = true
        
        let res = await this.treeDataApi(this.treeDataParams)  //树数据
        let  resc = await this.treeCountApi(this.treeCountParams) //统计数据
        this.loading = false
        const body = res && res.body ? res.body : {}
        let list = body.list || []
        const bodyc = resc && resc.body ? resc.body : {}
        let stat = bodyc.list || []
        //筛选无关联的统计项归类为新增的树节点“无关联”
        const newResult = this.createNoRelationNode(list,stat)
        list = newResult.newList
        stat = newResult.newStat
        //初始化左侧树：遍历左侧树和stat list<map>，第一次遍历将指定code的number赋值，第二次遍历把子节点的数据求和
        let treeList = this.modifyTreeConfig(list,stat)
        this.addTreeNumber(treeList)
        this.treeList = treeList   
      },
       createNoRelationNode(list,stat){
        let keyAttr = [] //存储无关联的编码数组，用于过滤右侧表格
        var hasNoRelation = false //标记是否要创建无关联树节点
         stat.map(e=> {
          var node = this.deepQuery(list,e.code) 
            if(!node){
              keyAttr.push(e.code)
              hasNoRelation = true
              e.code = this.noRelationProps.noRelationKey        //修改当前编码为无关联
            }
          })
          if(hasNoRelation){
            var obj ={}
            obj[this.defaultProps.dataName] = this.noRelationProps.noRelationValue
            obj[this.defaultProps.dataCode] = this.noRelationProps.noRelationKey
            obj.truekey = keyAttr
            obj.parentId = 'root'
            obj.children = []
            const root =  list[0]
            if(root && root.specialName == '全部'){
              list[0].children.push(obj)
            }else{
              list.push(obj)
            }
          }
          return {newList:list,newStat:stat}
       },
       //深度查找节点
       deepQuery(tree,target){
        var codeLabel = this.defaultProps.dataCode
        var isGet = false;
        var retNode = null;
        function deepSearch(tree,target){
            for(var i = 0; i<tree.length; i++) {
                if(tree[i].children && tree[i].children.length>0) {
                    deepSearch(tree[i].children,target);
                }
                if(target === tree[i][codeLabel] || isGet) {
                    isGet||(retNode = tree[i]);
                    isGet = true;
                    break;
                }
            }
        }
        deepSearch(tree,target);
        return retNode;
      },
       //递归树构造
       modifyTreeConfigNoNumber(list){
        if(list!=null && list.length > 0){
          return list.map(e => ({ obj:this.defaultProps.useKey?JSON.parse(JSON.stringify(e, this.defaultProps.useKey)):null, label: e[this.defaultProps.dataName], truekey:e.truekey,treeKey: e[this.defaultProps.dataCode], number:null,children:this.modifyTreeConfigNoNumber(e.children)}))
        }
      },
       //递归树构造
       modifyTreeConfig(list,stat){
        if(list!=null && list.length > 0){
          list.map(e=> {
            e.obj = this.defaultProps.useKey?JSON.parse(JSON.stringify(e, this.defaultProps.useKey)):null
            e.label = e[this.defaultProps.dataName]
            e.treeKey = e[this.defaultProps.dataCode]
            e.children = this.modifyTreeConfig(e.children,stat)
            e.number = 0
            let value = e[this.defaultProps.dataCode]
           stat.map(item=> {
            if(value == item.code){
                if(item.number && item.number != null){
                  e.number += item.number
                }
            }
           })
         })
          return list
        }
        return null
      },
       //子节点Number求和
       addTreeNumber(list){
        let total = 0
        if(list!=null && list.length > 0){
          list.map(e => {
            let  sonValues = this.addTreeNumber(e.children)
            let value = e.number
            if(value == null){
              value = 0
            }
            value = value + sonValues
            e.number = value
            total = total + value
         })
        }
        return total
      },
      //树节点点击事件：拼接子节点key
      fetchTableGetQueryCode(item){
        console.log("自定义树组件的点击事件=====", item);
        //根据选择节点过滤右侧表格
        let codeStr = item.treeKey
          console.log('当前点击的节点====',codeStr)
          var containsNull = ''
          if(codeStr=='root'){  //根节点查询全部
            codeStr = ''
          }else if(codeStr==this.noRelationProps.noRelationKey && !this.noRelationProps.noRelationKeyQuery){ //无关联节点查询
             codeStr = item.truekey.join(",")
             containsNull = 'containsNull'
          }else{
            codeStr  = this.joinTreechildrenCodes(item.children,codeStr)
            if(codeStr != '' && codeStr.indexOf(',') > -1){
              codeStr = codeStr.substring(0,codeStr.length - 1)
            }
          }
          console.log('已选树节点集合===='+codeStr)
        //保留扩展方法，在页面增加其他响应方法
        this.fetchTableDataFn(codeStr,item,containsNull)
      },
       //递归拼接树节点的子专项编码字符串，用于过滤右侧数据
       joinTreechildrenCodes(dicChild,codeStr){
        if(dicChild!=null && dicChild.length > 0){
          codeStr += ','
          dicChild.forEach(e => {
            if(e.treeKey != ''){
              codeStr += e.treeKey + ','
            }
            codeStr = this.joinTreechildrenCodes(e.children,codeStr)
          })
        }
        return codeStr
      },
      getTree(){
         //初始化
       if(this.numberLoad){
          this.handleSpecialCodeTree()
        }else{
          this.handleCodeTree()
        }
      }
    },
    created() {
       this.getTree()
    }
    // mounted() {
    //   this.$nextTick(() => {
    //       this.getTree()
    //   })
    // }
  }
  


// WEBPACK FOOTER //
// ./src/mixins/getMultiTree.js